<template>
  <div class="summary d-flex">
    <div class="statistic d-flex flex-grow-1 px-3 justify-content-between">
      <div class="">
        <span>{{ $t("unit.total") }}</span>
        <h6>{{ total }}</h6>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    total: {
      type: null,
      default: 0,
    },
  },
}
</script>
<style lang="scss" scoped>
.summary {
  border: solid 1px #f5f5f5;
  padding: 10px 0;
  background: white;
}
.statistic {
  span {
    font-size: 11px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.64;
  }
  h6 {
    margin: 0;
    font-size: 22px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 0.77;
    margin-top: 5px;
  }
}
</style>
